'use client';

import type { TChipSize } from '@umodeapporg/ui/components/UI/Chips/chipTones';
import OutlinedChip from '@umodeapporg/ui/components/UI/Chips/OutlinedChip';

import { MOTIVO_VISUAL } from '@/domain/fila/helpers/motivoVisual';
import type { FilaTipo } from '@/domain/fila/interfaces/fila';

interface IMotivoChipProps {
  tipo: FilaTipo;
  /** What the chip reads: the reason's name, as the owner set it in Settings. */
  label: string;
  size?: TChipSize;
}

/**
 * One reason, always with the same tone and the same icon: in the row, in the ignored list,
 * on the home preview and in the help, so the colour is learned once and read everywhere.
 */
export function MotivoChip({ tipo, label, size = 'xs' }: IMotivoChipProps) {
  const { tone, variant = 'soft', icon } = MOTIVO_VISUAL[tipo];

  return (
    <OutlinedChip
      label={label}
      tone={tone}
      // The label never breaks: a reason cut in two lines is what made the rows uneven.
      className="whitespace-nowrap"
      variant={variant}
      size={size}
      chipIcon={icon}
      chipIconSize={14}
      preserveLabelCase
    />
  );
}
